import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { EventModel } from 'src_common/common/websocket2/models/EventModel';
import { MatchLead } from 'src/domains/sportsbook/webview/components/matchLead/MatchLead';
import { MatchLeadNBA } from 'src/domains/sportsbook/webview/components/matchLead/matchLeadNBA/MatchLeadNBA';
import { MatchLeadMLB } from 'src/domains/sportsbook/webview/components/matchLead/matchLeadMLB/MatchLeadMLB';
import { LiveTracker } from 'src/domains/sportsbook/webview/components/scoreboards/liveTracker/LiveTracker';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { ConfigType } from 'src/domains/layouts/config/features/types';

interface PropsType {
    event: EventModel | null;
}

const isGeniusSportEnabled = (
    scoreboard: ConfigType['scoreboard'],
    sport: string,
    geniusScoreboardsEnabled: boolean
): boolean => {
    if (geniusScoreboardsEnabled !== true) {
        return false;
    }

    const inGameTracker = scoreboard.geniusGameTracker?.some((item) => item === sport) === true;
    const inScoreboard = scoreboard.geniusScoreboard?.some((item) => item === sport) === true;
    return inGameTracker || inScoreboard;
};

export const MatchLeadWrapper = observer<PropsType>('MatchLeadWrapper', ({ event }) => {
    const common = useCommon();
    const configComponents = ConfigComponents.get(common);
    const { scoreboard, liveTrackerForFootballOutrights, geniusScoreboardsEnabled } = configComponents.config;

    if (event === null) {
        return null;
    }

    const competitionData = event.competition2.getModel()?.getData();

    if (competitionData === undefined) {
        return null;
    }

    /**
     * Hide standard scoreboard for StarSport
     * @description
     * Sport: cricket;
     * competition: 'England County Championship Division One'
     * competition: England County Championship Division Two
     */
    if (
        competitionData.sport === 'cricket' &&
        (competitionData.name === 'England County Championship Division One' ||
            competitionData.name === 'England County Championship Division Two')
    ) {
        return null;
    }

    if (
        liveTrackerForFootballOutrights === false &&
        event.template === 'outrights' &&
        competitionData.sport === 'football'
    ) {
        return null;
    }

    if (event.template.startsWith('two-participant')) {
        if (competitionData.name.includes('Major League Baseball') === true) {
            if (isGeniusSportEnabled(scoreboard, 'baseball', geniusScoreboardsEnabled)) {
                return <MatchLead event={event} />;
            }

            return (
                <>
                    <MatchLeadMLB
                        key={event.id}
                        event={event}
                    />
                    {event.template !== 'outrights' && scoreboard.liveTracker?.includes('baseball') === true && (
                        <LiveTracker
                            sport={event.sport}
                            eventId={event.id2.toOldId()}
                            isOpen={event.timeMatchInPlay}
                        />
                    )}
                </>
            );
        }

        if (competitionData.name.split(' ').includes('NBA') === true) {
            if (
                isGeniusSportEnabled(scoreboard, 'basketball', geniusScoreboardsEnabled) ||
                scoreboard.liveTracker?.includes('basketball') === true
            ) {
                return <MatchLead event={event} />;
            }

            return (
                <MatchLeadNBA
                    key={event.id}
                    event={event}
                />
            );
        }
    }

    return <MatchLead event={event} />;
});
